import styled from "styled-components";

/** Header (linha superior com Olá, Ayrton! e a notificação) */
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: linear-gradient(
    269.86deg,
    rgba(6, 217, 134, 0.3) 0%,
    rgba(74, 118, 251, 0.3) 100%
  );
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

/** Título “Olá, Ayrton!” */
export const WelcomeTitle = styled.h1`
  display: flex;
  font-family: Inter;
  font-weight: 400;
  font-size: 22px;
  line-height: 27.4px;
  letter-spacing: -0.23px;
`;

/** Contêiner que agrupa o badge e o “avatar” */
export const NotificationWrapper = styled.div`
  position: relative;
`;

/** Badge de notificação (bolinha vermelha) */
export const NotificationBadge = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ef4444; /* Tailwind “bg-red-500” */
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  font-family: Inter;
  font-weight: 400;
  font-size: 10px;
  line-height: 11.2px;
  letter-spacing: 0%;
`;

/** “Avatar” cinza (fake) */
export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: #e5e7eb;
  box-shadow: 0px 4px 4px rgba(102, 102, 102, 0.2);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const Title = styled.h1`
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
  line-height: 29.05px;
  letter-spacing: -1%;
  background: linear-gradient(to right, #1f2937, #4b5563);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Content = styled.div`
  width: 100%;
  background-color: #f5f5f5;
`;

export const Card = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  padding: 8px 0;
  text-decoration: none;
  height: 100%;
  border-radius: 18px;

  &:first-child {
    padding-left: 16px;
  }

  &:last-child {
    padding-right: 16px;
  }

  &:hover {
    background-color: #f3f6ff;
  }
`;

export const TextCard = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #2d5bff;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;
